import { render, staticRenderFns } from "./ConsumersView.vue?vue&type=template&id=0dcdf703&lang=pug&"
import script from "./ConsumersView.vue?vue&type=script&lang=ts&"
export * from "./ConsumersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports